export default class DtoParameterGroupUsage {
    constructor(obj = {}) {
        this.parameter = obj.parameter
        this.groupCode = obj.groupCode
        this.groupName = obj.groupName
        this.labelWithCode = `${obj.groupName} [${obj.groupCode}]`
    }
}
